<template>
  <div class="store-brand-combine-container">
    <div class="main">
      <div>{{ data.tag_custom || '--' }}</div>
      <div class="handle" @click="handelClick"><i class="el-icon-edit"/></div>
    </div>
    <el-dialog :title="`「${data.name}」的分类标签`" :visible.sync="dialogCombine" width="420px" center append-to-body>
      <el-input v-model="tag_custom" placeholder="示例：顶级、二线、洗护" style="width: 100%"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCombine = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="handelSubmit" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {storeTag} from "@/api/brand";
import {combineBrandLikeQuery} from "@/api/combine";

export default {
  name: "StoreTag",
  props: {
    // {id: null, name: null, tag_custom: null}
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogCombine: false,
      combineOptions: [],
      tag_custom: null,
    }
  },
  watch: {
    "data.tag_custom"(_) {
      this.tag_custom = _
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.tag_custom = this.data.tag_custom
  },
  methods: {
    async handelRemoteCombine(query) {
      const response = await combineBrandLikeQuery({value: query})
      this.combineOptions = response.model || []
    },
    async handelSubmit() {
      const _this = this;
      const response = await storeTag({id: _this.data.id, tag_custom: _this.tag_custom});
      if (!response.success) {
        this.$message.error(response.message)
        return false;
      }
      _this.$emit('success')
      this.dialogCombine = false;
      this.$message.success('操作成功')
    },
    handelClick() {
      const _this = this;
      _this.dialogCombine = true;
    }
  }
}
</script>

<style lang="scss">
.store-brand-combine-container {
  .main {
    display: flex;
    justify-content: space-between;

    div:first-child {
      width: 150px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .handle {
      color: #ff3176;
    }
  }
}
</style>